import React from 'react';
import { MarketingImage } from 'components/MarketingPagesShared/MarketingImage';
import { MarketingBoldLink } from 'components/MarketingPagesShared/styles';
import { useT } from 'client/i18n/hooks/useT';
import {
  HomeImageCaption,
  HomeSectionTitle,
  HomeIconedCaption,
} from '../../../styles';
import { HomeSectionWithBackground } from '../../HomeSectionWithBackground';
import { CreateIcon } from '../../icons/CreateIcon';

export function HomeCreate({ onClickCTA }: { onClickCTA?: () => void }) {
  const t = useT();
  return (
    <HomeSectionWithBackground
      backgroundImagePath="bg-create.svg"
      textColumn={
        <>
          <HomeSectionTitle
            dangerouslySetInnerHTML={{
              __html: t(
                'HomePage.HomeCreate.Title',
                '<strong>Built-in uploading, recording, and editing tools</strong> so you can easily create and publish episodes.',
                'Anchor home page creation tools section title'
              ),
            }}
          />
          <MarketingBoldLink to="/features#creation" onClick={onClickCTA}>
            {t(
              'HomePage.HomeCreate.CreationFeaturesLinkText',
              'See all creation features',
              'Anchor home page creation features link text'
            )}
          </MarketingBoldLink>
        </>
      }
      imageColumn={
        <>
          <MarketingImage
            width={520}
            height={520}
            imagePath="home/create"
            alt={t(
              'HomePage.HomeCreate.CreationImageAlt',
              '{hostName} smiling and listening to the playback of a podcast on her phone',
              'Anchor home page creation image screenreader information',
              { hostName: 'Athena Calderone' }
            )}
          />
          <HomeIconedCaption>
            <CreateIcon />
            <HomeImageCaption
              dangerouslySetInnerHTML={{
                __html: t(
                  'HomePage.HomeCreate.CreationImageCaption',
                  '{hostName} records <strong>“{podcastName}”</strong> from home.',
                  'Anchor home page creation image caption',
                  {
                    hostName: 'Athena Calderone',
                    podcastName: 'More Than One Thing',
                  }
                ),
              }}
            />
          </HomeIconedCaption>
        </>
      }
    />
  );
}
